/* unplugin-vue-components disabled */export default defineComponent({
  name: 'Communication',
  components: {},
  setup: function setup() {
    var activeNames = ref(['1']);
    return {
      activeNames: activeNames
    };
  }
});